import { motion, useScroll, useSpring } from "framer-motion";

export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scale = useSpring(scrollYProgress, { stiffness: 120, damping: 20, mass: 0.2 });
  return (
    <motion.div
      data-testid="scroll-progress"
      style={{ scaleX: scale, transformOrigin: "0% 50%", background: "linear-gradient(90deg, #1E3A8A, #10B981)" }}
      className="fixed top-0 left-0 right-0 h-[3px] z-[60]"
    />
  );
}
